export const types = {
  CLOSE_INSTALL_FOOTER: 'CLOSE_INSTALL_FOOTER',
};

export const closeInstallFooter = () => ({
  type: types.CLOSE_INSTALL_FOOTER,
});

const INIT_STATE = {
  inactive: false,
};

export default function(state = INIT_STATE, action) {
  switch (action.type) {
    case types.CLOSE_INSTALL_FOOTER: {
      return {
        ...state,
        inactive: true,
      };
    }
    default:
      return state;
  }
}

export const getInactive = state => state.footer.inactive;



// WEBPACK FOOTER //
// ./app/redux/footer.js